import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { Row, Col, Switch, Radio } from 'antd'

const CollapsibleCardFacility = ({ onSetFieldValue, data, values, isOpen }) => {
  const [open, setOpen] = useState(isOpen)

  const handleCardVisibility = checked => {
    setOpen(checked)
  }

  useEffect(() => {
    handleCardVisibility(isOpen)
  }, [isOpen])

  return (
    <div
      className={cx('search-form__card search-form__card--collapsible', {
        'search-form__card--compact': !open,
      })}
    >
      {!open && (
        <Row justify="space-between">
          <Col>
            <div className="ant-form-item-label">
              <label>Advanced Search</label>
            </div>
          </Col>
          <Col>
            <Switch onChange={handleCardVisibility} defaultChecked={open} />
          </Col>
        </Row>
      )}
      {open && (
        <>
          <Row justify="space-between">
            <Col>
              <div className="ant-form-item-label">
                <label>Advanced Search</label>
              </div>
            </Col>
            <Col>
              <Switch onChange={handleCardVisibility} defaultChecked={open} />
            </Col>
          </Row>
          <div className="ant-form-item">
            <div className="ant-col ant-form-item-label">
              <label title="Special release form attached">
                Special release form attached
              </label>
            </div>
            <Radio.Group
              initialValue={data.has_active_special_release_form}
              name="has_active_special_release_form"
              onChange={({ target: { value, name } }) => {
                onSetFieldValue(name, value)
              }}
              value={values.has_active_special_release_form}
              buttonStyle="solid"
            >
              <Radio.Button value="all">All</Radio.Button>
              <Radio.Button value="true">Attached</Radio.Button>
              <Radio.Button value="false">Not Attached</Radio.Button>
            </Radio.Group>
          </div>
        </>
      )}
    </div>
  )
}

export default CollapsibleCardFacility
